import React, { ReactNode, useCallback } from 'react';
import classnames from 'classnames';
import { Button } from 'zarm';
import './button.scss';

interface ButtonProps {
  prefixCls?: string;
  buttonClick?: any;
  text?: string | ReactNode;
  disabled?: boolean;
  buttonPrefixCls?: string;
  buttonShape?: any;
  loading?: boolean;
}

const FixedButton = (props: ButtonProps) => {
  const { prefixCls, buttonClick, text = '下一步', disabled = false, buttonPrefixCls = '', buttonShape = 'radius', loading = false } = props;

  const click = useCallback(() => {
    typeof buttonClick === 'function' && buttonClick();
  }, [buttonClick, disabled]);

  return (
    <div className={classnames('fixedbutton_component', prefixCls)}>
      <div className="fixed_part">
        <Button
          block
          className={classnames('next_step_btn', buttonPrefixCls)}
          theme="primary"
          onClick={click}
          disabled={disabled}
          shape={buttonShape}
          loading={loading}
        >
          {text}
        </Button>
      </div>
    </div>
  );
};

export default FixedButton;
